import List from "@/components/list";
import Bus from "../../../pages/creditRule/Bus.js";

const Table = args => {
  function handleUpdate({ row }) {
    Bus.$emit("handleUpdate", row);
  }

  function handleDelete({ row }) {
    Bus.$emit("handleDelete", row);
  }

  const Deal = ({ props: { vo } }) => {
    const creditRule = vo.row;
    const dealConf = [
      /*["el-icon-circle-check", "提交", () => handleUpdate(), "creditRule:update"],*/
    ];
    if (creditRule.uuid == null || creditRule.uuid == "") {
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => handleDelete(creditRule),
        "creditRule:update"
      ]);
    } else {
      dealConf.push([
        "icon-delete",
        "删除",
        () => handleDelete(creditRule),
        "creditRule:update"
      ]);
    }
    return (
      <div class="deal-group">
        <el-tooltip
          content="提交"
          v-permission={"creditRule:update"}
          placement="top"
        >
          <i
            class="el-icon-circle-check"
            style="font-size: 18px"
            onClick={() => handleUpdate(creditRule)}
          ></i>
        </el-tooltip>
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "图书类型",
      prop: "typeName"
    },
    {
      label: "分值",
      prop: "ruleValue",
      render: e => {
        const item = e.row;
        return (
          <el-input
            placeholder="请输入分值"
            key={item.ruleKey}
            value={item.ruleValue}
            style={"width:85px"}
            size="small"
            onClick={function(event) {
              item.ruleValue = event.target.value;
            }}
          ></el-input>
        );
      }
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
